/** Claude subscription quota — not a crash, and retrying cannot work until reset. */
export function parseSessionLimit(error: string): { resetAt: string } | null {
  if (!error || !/session limit/i.test(error)) return null;
  const m = error.match(/resets\s+(.+)/i);
  return { resetAt: m?.[1]?.trim() ?? "" };
}

/** A turn left mid-flight because the server process went away. */
export function isInterrupted(status: string, error: string): boolean {
  return status === "interrupted" || /interrupted by a server restart/i.test(error);
}
